import React, { useState, useEffect } from "react";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import { FlatList, View, StyleSheet, TouchableOpacity, ScrollView,Platform, Image, Dimensions } from "react-native";
//import { Image } from "react-native-expo-image-cache";
import { Video, Audio, AVPlaybackStatus } from 'expo-av';
import { MaterialCommunityIcons, Entypo, Foundation } from "@expo/vector-icons";
import VideoVisor from "./VideoVisor";
import * as Linking from 'expo-linking';
//import { WebView } from 'react-native-webview';
//import Hyperlink from 'react-native-hyperlink'; // Agregado al proyecto el 22-2-2022.

import dateNow from "../utility/dateNow";
import dateActions from "../utility/dateActions";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";      
import Text from "./Text";
import colors from "../config/colors";
import ChooseTypeContent from "./ChooseTypeContent";
import CardOriginComponent from "./CardOriginComponent";
import CardRequirements from "./CardRequirements";
import routes from "../navigation/routes";
import CardFeed from "./CardFeed";
import textStyles from "../config/textStyles";
import { PieChart } from "react-native-chart-kit";
import { ListImageItem, ListItemAccount, ListItemSeparator } from "./lists";
import ImageHandlerDichapp from "../utility/ImageHandlerDichapp";


var windowWidth = Dimensions.get('window').width;

    var profileUri = ''
    var webUrl = ''
    var seedVideoUri = ''
    //console.log('FeedScreen ->', connectionConfig.switchS3)
    if (connectionConfig.switchS3 === true) {
        //console.log('FeedScreen -> guarda las imagenes en un bucket de aws S3')
        profileUri = connectionConfig.imageUrlS3
        webUrl = connectionConfig.imageUrlS3
        seedVideoUri = connectionConfig.imageUrlS3
        //debugger
    } else {
        console.log('else switchS3')
        profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
        webUrl = connectionConfig.imageUrl + '/seedImages/'
        seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
    }
var date = dateNow()
var numLikes = 0
var sizeBrainComments =  textStyles.sizeBrainComments// Tamaño icono cerebro y comments


function CardComponent({ 
                type,
                title,
                seedDescription, 
                seedId,
                seedName,
                seedPhoto,
                origin,
                subTitle, 
                imageUrl, 
                onPress, 
                //onPressLike,  12-9-21 Dejó de traerse como parámetro porque los likes se deben de hacer desde aqui en vez de en ListingDetailsSeedScreen. 
                onPressComment, 
                onPressNumLikes, 
                thumbnailUrl,
                commentsNum,
                actionsNum,
                videoNumber,
                documentSeed,
                userId,
                getContentActions,
                foundUserChecker,
                seedDate,
                content,
                seedOrder,
                onPressShare,
                totalSeedLikes ,
                totalSeedComments,
                userPhoto,
                userName,
                urlOG
                }) {

const navigation = useNavigation(); // esto te sirve para navegar en el ambiente donde invocaste este componente
const video =React.useRef(null);
const [status, setStatus] = useState({});
const [itemsSupport, setItemsSupport] = useState([]);
var dateFormated = dateActions(seedDate)
var dateToNumber = Date.parse(seedDate)
const [seePriceSub, setSeePriceSub] = useState("no");
const [verMasApoyos, setVerMasApoyos] = useState("menos");
const [verMas, setVerMas] = useState("menos");
// ****** Variables para los componentes de Requerimientos ********
const [itemsRequirements, setItemsRequirements] = useState([]);
var qtyItemsRequirements = (itemsRequirements.length) // Esto nos da la cantidad de items en el array de requerimientos 39
var qty = 0
var mesure = "piezas"
var unitaryPrice = 0
var currency = "pesos Mx"
var sub = 0
var note = ""
var newSeedId = 0  //Este en particular se usa para dar de alta un nuevo requerimiento 40 en addRequirement40.

// *****************************************************************

const [lastComponent, setlastComponent] = useState(''); // Hook para que no se corte el último componente x la barra de Show Actions


useEffect(() => {
  //debugger
  if (type === 44) {
      //console.log("*** Content en If 44 jeje en useEfect CardComponent ", "content")
      selectMultiImages()
  }
  bringSupportItems()
  bringRequirementItems()
 // ifBringRequirementItems()
  detectSeedIndex()
  }, [seedId, type]);

//---------------------------------------------
//Obtiene el documento de la info
//---------------------------------------------
const retriveDoc = async () => {
  //debugger
      if(documentSeed.includes('.pdf')){    // antes era if(filtroListing.documentSeed.includes('.pdf')) pero le quité el filtroListing porque documentSeed viene por parámetro.
           //Linking.openURL(infoDocumetUri +'pdfSeeds/'+ listing.documentSeed) 
           Linking.openURL(infoDocumetUri +'pdfSeeds/'+ documentSeed) 

      } 
      if(documentSeed.includes('.png')){
          //Linking.openURL(infoDocumetUri + 'imageSeedsPng/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'imageSeedsPng/' + documentSeed)

      }
      if(documentSeed.includes('.jpg')){
          //Linking.openURL(infoDocumetUri + 'imageSeedsB/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'imageSeedsB/' + documentSeed)

      }
      if(documentSeed.includes('.xls')){
          //Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + documentSeed)
      }
      if(documentSeed.includes('.xlsx')){
          //Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + listing.documentSeed)
          Linking.openURL(infoDocumetUri + 'ExcellSeeds/' + documentSeed)
      }
}



// ***************************************     Inicia block de los likes    ***************************************************
//---------------------------------------------------------------------------------------------------------------------------
//  1. Servicio que valida si ya existe el like del usuario en la publicación (función inicio del encadenamiento de servicios) 
//---------------------------------------------------------------------------------------------------------------------------
const onPressValidationLikeUser = async () => {

  console.log("Este es el SeedId en rutina likes CardComponent ", seedId )
  try {
    const { sound } = await Audio.Sound.createAsync(
      require('../assets/sounds/ringtones-heart.mp3')   // Ejecuta un sonido al hacer like  
    )
    await sound.playAsync()
  } catch (err) {
    console.log(':(', err )
  }
  //debugger
  var post_values = {
   seedId :  seedId, //filtroListing.seedId,
   userId :  userId  //JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/SelectValidateSeedsLikes/', configurationPost)
  .then(response => response.json())
  .then(response => {
    if (response.data.length != 0) {   
       deleteLikePublication()
    } else {
      insertLike()           
     }
  })
  .catch(err =>{
  console.log(':( review internet service', err )
  })
}

//--------------------------------------------------------
// 2. servicio que borra el like si ya existe en la publicación
//---------------------------------------------------------
const deleteLikePublication = async () => {
  var post_values = {
    seedId : seedId,
    userId : userId  //JSON.parse(user).userId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/deleteLikeSeeds/', configurationPost)
  .then(response => response.json())
  .then(response => {
    countOfLikes()
   })
   .catch(err =>{
   console.log(':( review internet service /deleteLikeSeeds/', err )
   })
}   

//-------------------------
// 2.1. Agrega un nuevo like 
//-------------------------
const insertLike = async  () => {
   // debugger
  var post_values = {
      seedId : seedId,    //filtroListing.seedId, 
      userId : userId,    //JSON.parse(user).userId,
      dateLikeSeed : date,
      likeType : 1
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/insertSeedLike/', configurationPost) 
  .then(response => response.json())
  .then(response => {
    countOfLikes()    
  })
  .catch(err =>{
  console.log('Insert fixo failed :( review internet service -> insertSeedLike', err )
  })
}

//------------------------------------------------------------------
// 3. Servicio que nos va a traer el count de likes por semilla.
//------------------------------------------------------------------
const countOfLikes = async () => {
   var post_values = {
      seedId : seedId    //filtroListing.seedId, 
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/SelectCountSeedLikes/', configurationPost)
   .then(response => response.json())
   .then(response => {
     numLikes = response.data[0].total_likes
     incrementLikes()
     
   })
   .catch(err =>{ 
   console.log(':( review internet service => /SelectCountSeedLikes/', err )
   })
}
//------------------------------------------------------------------------------
// 4. servicio que hace un incremeto al campo de número de likes de una semilla
//------------------------------------------------------------------------------
const incrementLikes = async () => {
        //debugger

        var post_values = {
          seedId : seedId, //filtroListing.seedId, 
          totalSeedLikes : numLikes
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/UpdateIncrementLikeSeeds/', configurationPost) 
      .then(response => response.json())
      .then(response => {
      getContentActions2()
      })
      .catch(err =>{
      console.log('Insert fixo failed :( review internet service /UpdateIncrementLikeSeeds/', err )
      })
}

//------------------------------------------------------------------------------------------
// Función que invoca la función getContentActions via props desde ListingDetailsSeedScreen 
//------------------------------------------------------------------------------------------
const getContentActions2 = async () => {
  getContentActions()
}
// ********************************************* Termina block de los likes  *********************************************//



// ----------------------------------------------------------------------------------
//  Funciónes para traer los items del componente 39 (Requerimientos)
// ----------------------------------------------------------------------------------
// const ifBringRequirementItems = async () => {
// bringRequirementItems()
// }

const bringRequirementItems = async () => {
//debugger
  var post_values = {
   origin: seedId,  // Lleva el seedId en origin para que busque los renglones de requerimientos.
   type: type
}

configurationPost.body = JSON.stringify(post_values)


await fetch(connectionConfig.apiUrl+'/SelectSupportActions/', configurationPost)//console.log("response ", response)

     .then(response => response.json())
     .then(response => {
      setItemsRequirements(response)
     } )
     .catch(err =>{
          console.log('bringRequirementItems /selectRequirementActions/ failed :( review internet service)', err )
     })
 
  }
// ----------------------------------------------------------------------------------


//---------------------------------------------------
// Función para generar el seedId para el componente
//---------------------------------------------------
const addRequirement40 = async () => {
 
  seedDate = date
  
  console.log("seedId en addRequirement40 en CardComponent ", seedId)
 
  var post_values = {
      userId           : userId,
      createDateSeed   : date,
      type             : 40,
      origin           : seedId,
      seedName         : 'Título... ',
      seedDescription  : 'Descripción... ',
      seedPhoto        : 'Poner Foto ',
      documentSeed     : 'Poner documento',
      youtubeId        : 'link',
      seedOrder        : 999
 
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/insertAction/', configurationPost)
    .then(response => response.json())
    .then(response => {
      console.log( {response} + "Response despues de post GenerateActionId ChooseTypeContent")
      newSeedId = response.data.insertId
      //seedId = newSeedId
      console.log("Este es el nuevo seedId desde ChooseTypeContent: " + newSeedId)
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /insertAction/', err )
    })
    selectInfoAction()
 };
 
 
     const selectInfoAction = async () => {
       origin = seedId  //origin 
       seedId = newSeedId
       foundUserChecker = foundUserChecker
       seedDate = date
       type = 40
       seedOrder = 999
       var screen = 'ChooseTypeContent'
       var changeListing = 'true'
        navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, seedDate, seedOrder, screen } ) 
     }
 
 


//-----------------------------------------------------------------------------------
//  Funciones para hacer que la parte de hasta abajo del último componente no 
//  se corte por la barra de ShowActions.
//  Esto se logra haciendo más grande la altura del view del componente en caso de 
//  ser el último index del array.
//----------------------------------------------------------------------------------- 
var contentNumber = ((content).length)-1
var indexSeed = ''
const detectSeedIndex = async () => {
  indexSeed = content.findIndex((element) => (element.seedId === seedId ) );  //String(props.seedId)
  if(indexSeed === contentNumber){
    setlastComponent("last")
  } else {
    setlastComponent("")
  }
}

const bringSupportItems = async () => {
  var post_values = {
   origin: seedId,  // Lleva el seedId en origin para que busque los renglones de requerimientos.
   type: 41  //type40
}
configurationPost.body = JSON.stringify(post_values) 

//await fetch(connectionConfig.apiUrl+'/selectRequirementActions/', configurationPost)
await fetch(connectionConfig.apiUrl+'/SelectSupportActions/', configurationPost)

     .then(response => response.json())
     .then(response => {
      setItemsSupport(response)
     } )
     .catch(err =>{
          console.log('bringRequirementItems /selectRequirementActions/ failed :( review internet service)', err )
     })

}

// ********** Código para sumar los items de cada apoyo de un requerimiento **************
var qtySupports = (itemsSupport.length) // Este en particular es para sacar los apoyos de un requerimiento en particular.
var sumSupports = ''
sumSupports = itemsSupport.map((element) => (element.qty) ); 
var totalSupports = 0
//totalSupports = sumSupports.reduce(function(a, b){ return a + b, 0 }) // Esta forma antigua de escribir js no le gusta a recat native
totalSupports = sumSupports.reduce((a, b) => a + b, 0 ); // Con esta forma nueva si la reconoce react native :)

var requirementsToFulfill = 0    // Requerimeintos por completar
requirementsToFulfill = (qty - totalSupports)     

var percentageSuccess = 0       // Porcentaje de requerimientos completados 
percentageSuccess = (totalSupports/qty)*100

if(percentageSuccess === 0){    // Ifeo para meterle sólo dos decimales al resultado (si es distinto de cero)
  percentageSuccess
} else{
percentageSuccess = percentageSuccess.toFixed(2)  // Método en si para ponerle decimales (dos) 
}
//********** Datos para la gráfica de requerimientos **********
const pieData = [
  { 
    value: totalSupports === 0 ? 0 : totalSupports, 
    color: '#35AB20', 
    name: 'Progreso' , 
    legendFontSize: 15,
    legendFontColor: '#7F7F7F'
  },
  {
    value: requirementsToFulfill === 0 ? 1 : requirementsToFulfill,
     color: 'lightgray', 
     name: 'Pendiente' ,  
     legendFontSize: 15, 
     legendFontColor: '#7F7F7F'
  }
];

// ********** Código para Ifear la flecha para mostrar Precio U. y Subtotal **************
var ifShowPriceSub = ""
if(unitaryPrice !== 0 && seePriceSub === "no"){
  ifShowPriceSub = "show"
}else if(unitaryPrice !== 0 && seePriceSub === "yes"){
  ifShowPriceSub = "dontShow"
}else{
  null
}
//Función que se encarga de hacer la gráfica de pie
const MyPieChart = () => {
  return (
    <>
      <PieChart        
          data={pieData}
          chartConfig={{
          backgroundColor: '#1cc910',
          backgroundGradientFrom: '#eff3ff',
          backgroundGradientTo: '#efefef',
          decimalPlaces: 2,
          color: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
          style: {
            //borderRadius: 16,
            width:200,
            height:200
             // backgroundColor: "red"
           // margin:2
          },
        }}
        //estilos que impactan la gráfica por fuera
        style={{
          marginVertical: 8,
          marginLeft:10,
 
          borderRadius: 16,
        }}
        accessor="value"
        backgroundColor="transparent"
        padding="15"
        paddingLeft='10'
        width={300}
        height={200}
        //absolute //for the absolute number remove if you want percentage
      />
    </>
  );
};

  //---------------------------------------------
  //elementos para carrusel con pagination dots
  //---------------------------------------------
  const selectMultiImages = async () => {
    var post_values = {
      /// userId: userId,
      seedId: seedId,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelectMultplesImages/', configurationPost)
      .then(response => response.json())
      .then(response => {
        // console.log('/SelectMultplesImages/ -> pruebon' + seedId)
        //navigation.goBack();
        var arr = []
        arr = response.data
        setMultiImages(arr)
        // console.log('regresa cardComponent/SelectMultplesImages/ :)', response.data)
      })
      .catch(err => {
        console.log(':( review internet service /SelectMultplesImages/', err)
      })
  }

  const [currentIndex, setCurrentIndex] = useState(0);
  const [multiImages, setMultiImages] = useState([])

  const renderPage = (dataItem, num) => {
    var imageUrl = webUrl + dataItem.seedphoto

   // console.log(webUrl + dataItem.seedphoto)
    //console.log('    ' + imageUrl)
    return (
      <View key={dataItem.seedPhotoId} style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        {
          //.............................................
          //Sección que pinta imagenes o videos multiples
          //.............................................
          String(dataItem.seedphoto).includes('.jpg') === true ?
            <TouchableOpacity
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
                //alignItems: 'center',
                //backgroundColor: colors.mexicanPink
              }}
              onPress={() => {
                //console.log('pique la imagen', )
                try {
                  //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                  console.log('boton que va al visor cardComponent ->  1', imageUrl)
                  navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                } catch (error) {
                  console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                }
                // navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
              }}>
              <Image style={{
                width: '100%',
                height: '100%'
              }}
                resizeMode="contain"
                source={{ uri: imageUrl }}></Image></TouchableOpacity>
            :
            String(dataItem.seedphoto).includes('.jpeg') ?
              <TouchableOpacity  
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                onPress={() => {
                  //console.log('pique la imagen', )
                  try {
                    //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                    console.log('boton que va al visor cardComponent ->  1', imageUrl)
                    navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                  } catch (error) {
                    console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                  }
                  // navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                }}>
                <Image style={{
                  width: '100%',
                  height: '100%'
                }}
                  resizeMode="contain"
                  source={{ uri: imageUrl }}></Image></TouchableOpacity>
              : String(dataItem.seedphoto).includes('.mp4') ?
                <Video
                  ref={video}
                  style={{
                    width: '100%',
                    height: '100%'
                  }}
                  source={{
                    uri: imageUrl
                  }}
                  useNativeControls
                  resizeMode="contain"
                  isLooping
                  onPlaybackStatusUpdate={status => setStatus(() => status)}
                />
                :
                String(dataItem.seedphoto).includes('.mov') ?
                  <Video
                    ref={video}
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                    source={{
                      uri: imageUrl
                    }}
                    useNativeControls
                    resizeMode="contain"
                    isLooping
                    onPlaybackStatusUpdate={status => setStatus(() => status)}
                  />
                  : String(dataItem.seedphoto).includes('.png') ?
                    <TouchableOpacity
                        style={{
                          width: '100%',
                          height: '100%'
                        }}
                      onPress={() => {
                        //console.log('pique la imagen', )
                        try {
                          //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                          console.log('boton que va al visor cardComponent ->  1', imageUrl)
                          navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                        } catch (error) {
                          console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                        }
                        // navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                      }}> 
                      <Image 
                      style={{
                        width: '100%',
                        height: '100%'
                      }}
                        resizeMode="contain"
                        source={{ uri: imageUrl }}/>
                        </TouchableOpacity>
                    //  <Text style={{
                    //   width: 150,
                    //   height: 150
                    // }}>
                    //   {dataItem.seedPhotoId + imageUrl} entre en png</Text>
                    :
                    <Text style={{
                      width: 150,
                      height: 150
                    }}>
                      {dataItem.seedPhotoId + imageUrl} entre en null</Text>
        }

        {/* <Text style={{
          width: 50,
          height: 50
        }}>{dataItem.seedPhotoId} soy Id</Text> */}
      </View>
    );
  }
var img = webUrl + userId +'_'+ imageUrl.substring(0, 19) + '_userfit.jpg'  

switch (type) {

// S E E D  <===  T R A B A J A N D O  !!

case -1:   
    return (
      <CardFeed 
      type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                //imageUrl={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed}
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto
                }
                
                onPress={onPress}

                onPressLike={ () => {
                      // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                 }else{
                  onPressValidationLikeUser()
                 }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
      />
      // <CardOriginComponent
      //           type={type}  
      //           title={seedName}
      //           seedDescription={seedDescription}
      //           seedId={seedId}
      //           seedName={seedName} 
      //           seedPhoto={seedPhoto}
      //           origin={origin}
      //           subTitle={subTitle}
      //           videoNumber={videoNumber}
      //           documentSeed={documentSeed}
      //           userId={userId} 
      //           foundUserChecker={foundUserChecker}
      //           seedDate={dateFormated}
      //           content={content}
      //           onPressNumLikes={() => {
      //             console.log("presNumLique")
      //             }                  
      //           }
      //           imageUrl={
      //             seedPhoto.includes('.mp4') ?
      //             seedVideoUri + seedPhoto :
      //             seedPhoto.includes('.mov') ?
      //             seedVideoUri + seedPhoto :
      //             webUrl + seedPhoto}
                
      //           onPress={onPress}

      //           onPressLike={ () => {
      //             onPressValidationLikeUser()
      //            }
      //           }
      //           commentsNum={commentsNum}
      //           actionsNum={actionsNum}
      //           onPressComment={onPressComment}
      //           thumbnailUrl={thumbnailUrl}
      //         />
  );

case 0:   
    return (

      <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed}
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={onPress}

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
                urlOG={urlOG}
              />
  );


// A C T I O N  1   <==== Modo component 
case 1: 
  return (
<CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={onPress}

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />
  );


// S E E D   A C T I O N   1     <===  Modo Component
case 2:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={onPress}

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// S E E D  A C T I O N 3 <===  Modo Component
case 3:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={onPress}

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// S E E D  A C T I O N 4 <===  Modo Component
case 4:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={onPress}

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// S E E D  A C T I O N 5 <===  Modo Component
case 5:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={onPress}
                
                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// S E E D  A C T I O N 6 <===  Modo Component
case 6:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={() => {
                  console.log("onPress disponible por si gustas")
                  }
                }

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// S E E D  A C T I O N 7 <===  Modo Component
case 7:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={() => {
                  console.log("onPress disponible por si gustas")
                  }
                }

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// "8"  N O T A  ======> S E E D   A C T I O N 8  <=== Porque era acción de requerimiento y eso sólo ira en componente.


// S E E D  A C T I O N 9 <===  Modo Component
case 9:   
return (
  <CardOriginComponent
                type={type}  
                title={seedName}
                seedDescription={seedDescription}
                seedId={seedId}
                seedName={seedName} 
                seedPhoto={seedPhoto}
                origin={origin}
                subTitle={subTitle}
                videoNumber={videoNumber}
                documentSeed={documentSeed} 
                userId={userId} 
                foundUserChecker={foundUserChecker}
                seedDate={dateFormated}
                content={content}
                onPressNumLikes={() => {
                  console.log("presNumLique")
                  }                  
                }
                imageUrl={
                  seedPhoto.includes('.mp4') ?
                  seedVideoUri + seedPhoto :
                  seedPhoto.includes('.mov') ?
                  seedVideoUri + seedPhoto :
                  webUrl + seedPhoto}
                
                onPress={() => {
                  console.log("onPress disponible por si gustas")
                  }
                }

                onPressLike={ () => {
                  // if(JSON.parse(user).alias === 'notUser' ){
                if(Platform.OS === 'web' ){
                          // alert('notUser')
                navigation.navigate('ViewImage')
                }else{
                  onPressValidationLikeUser()
                }
                }
                }
                commentsNum={commentsNum}
                actionsNum={actionsNum}
                onPressComment={onPressComment}
                thumbnailUrl={thumbnailUrl}
              />

);


// Add text  <===  L I S T O !!
case 33:
  return (
    <View style={styles.viewContent4}>
                <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
                <Text style={styles.title} numberOfLines={1}> Type:  {type} {seedId} </Text>
                <Text style={styles.title} > SeedOrder:  { seedOrder } </Text>  

                <TouchableOpacity onPress={onPress}>
                <View style={styles.SelectComponentList} >
                {   
                foundUserChecker === "off" ?
                    <ChooseTypeContent 
                    navigation={ navigation } 
                    seedId={seedId}
                    origin={origin}
                    type={type} 
                    seedDescription={seedDescription}
                    seedName={seedName} 
                    seedPhoto={seedPhoto}
                    foundUserChecker={foundUserChecker}
                    seedDate={seedDate}
                    userId={userId}
                    content={content}
                    seedOrder={seedOrder}/>
                    :
                    null
                }
                </View>
               </TouchableOpacity>

            <View style={styles.Title}>
                <Text style={styles.Title}  > 
                  {title}
                </Text>
            </View>
          <View style={styles.detailsContainer}>
                <Text style={styles.seedDescription} >
                  {seedDescription}
                </Text>
                <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  onPress={onPressNumLikes}>
                                  {subTitle}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {commentsNum}
                            </Text>
                </View>

          </View>
          {
            lastComponent === "last" ? 
              <View style={{height: 60}}>
              </View>
            :
            null
          }
    </View>
);


// Add document <==================  SOLO F A L T A QUE NO TRUENE AL HACER GRANDE LOS ARCHIVOS EN EXCELL 5 SEP 2021 
case 34:
  return (
    <View style={styles.viewContent9}>
                <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
                <Text style={styles.title} numberOfLines={1}> Type:  {type} {seedId} </Text>
                <Text style={styles.title} > SeedOrder:  { seedOrder } </Text>  

              <View style={styles.SelectComponentList} >
              {   
                foundUserChecker === "off" ?
                    <ChooseTypeContent 
                    navigation={ navigation } 
                    seedId={seedId}
                    origin={origin}
                    type={type} 
                    seedDescription={seedDescription}
                    seedName={seedName} 
                    seedPhoto={seedPhoto}
                    foundUserChecker={foundUserChecker}
                    seedDate={seedDate}
                    userId={userId}
                    content={content}
                    seedOrder={seedOrder}/>
                    :
                    null
                }
               </View> 

               <Entypo
          onPress = { () => retriveDoc()}
          name={"resize-full-screen"}
          size={70}
          color={colors.lemonGreen}
          style={styles.resizeScreen}
          />                
          <View style={documentSeed.includes('.pdf') ? styles.imageViewViewer:
                       documentSeed.includes('.xlx') ? styles.imageViewViewerExcell:
                       documentSeed.includes('.xlsx')? styles.imageViewViewerExcell:
                       styles.imageViewViewer
                      }>
          {/* <View > */}

              { 
                 documentSeed.includes('.pdf')?
                 //<View  style={styles.imageViewViewer} >
                 // si es para app movil 
                //  <WebView 
                //  source= {{ uri: infoDocumetUri + 'pdfSeeds/' + documentSeed }} 
                //  /> 
                <iframe 
                    src = {infoDocumetUri + 'pdfSeeds/' + documentSeed }
                    title="iframe Example 1"
                    width="400"
                    height="300">       
                 </iframe>
                 //</View> 
               :
                documentSeed.includes('.xlx')?
                //<View  style={styles.imageViewViewer} >
                // <WebView 
                // source= {{ uri: infoDocumetUri + 'ExcellSeeds/' + documentSeed }} 
                // /> 
                <iframe
                src = {infoDocumetUri + 'pdfSeeds/' + documentSeed }
                //  src="http://localhost:19006/" 
                  title="iframe Example 1"
                  width="400"
                  height="300">       
                </iframe>
                //</View> 
              :
                documentSeed.includes('.xlsx')?
                //<View  style={styles.imageViewViewer} >
                // <WebView 
                // source= {{ uri: infoDocumetUri + 'ExcellSeeds/' + documentSeed }}
                // /> 
                <iframe
                   src = {infoDocumetUri + 'pdfSeeds/' + documentSeed }
                   // src="http://localhost:19006/" 
                    title="iframe Example 1"
                    width="400"
                    height="300">       
                </iframe>
                //</View> 
              :
              //<View style={styles.imageMountain} >
              <Foundation //style={styles.imageMountain}
                          name="mountains" 
                          size={350} 
                          color={colors.medium} />
              //</View>
              }
          </View> 
          

          <View style={styles.detailsContainer}>
                <Text style={styles.Title} >
                  {title}
                </Text>
                <Text style={styles.seedDescription} >
                  {seedDescription}
                </Text>
               <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  onPress={onPressNumLikes}>
                                  {subTitle}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {commentsNum}
                            </Text>
                </View>
          </View> 
    </View>
);


// Add photo or Video  <===  L I S T O !!
case 35:
  return (
    <View style={styles.viewContent5}>

               <View style={styles.SelectComponentList} >
               {   
                foundUserChecker === "off" ?
                    <ChooseTypeContent 
                    navigation={ navigation } 
                    seedId={seedId}
                    origin={origin}
                    type={type} 
                    seedDescription={seedDescription}
                    seedName={seedName} 
                    seedPhoto={seedPhoto}
                    foundUserChecker={foundUserChecker}
                    seedDate={seedDate}
                    userId={userId}
                    content={content}
                    seedOrder={seedOrder}/>
                    :
                    null
                }
               </View>

               <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
               <Text style={styles.title} > Type:  {type} </Text>

          {/* <TouchableOpacity onPress={onPress}> */}


            <View>
              <ImageHandlerDichapp
                    imageUrl={seedPhoto}
                    imageType="seed"
                    userId={userId}
                    //thumbnailUrl={thumbnailUrl}
                    styleImage={
                    styles.image5
                    }
                    styleImageVideo={styles.image5}
                    onPressImg={()=>{
                      var imageUrl = webUrl + seedPhoto + '_seedfit.jpg'
                                      navigation.navigate('Imagen', {
                                      imageUrl
                                      })

                      //console.log("Onpress en CardComponent onPressImg()")
                    }}
                    navigation={navigation}
                  />  
            </View>

          {/* </TouchableOpacity> */}
          <View style={styles.detailsContainer}>
                <Text style={styles.Title} >
                  {title}
                </Text>
                <Text style={styles.seedDescription} >
                  {seedDescription}
                </Text>
               <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  onPress={onPressNumLikes}>
                                  {subTitle}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {commentsNum}
                            </Text>
                </View>
          </View>
    </View>
);


// Add photo or Video  with Text to the  ==> L E F T <==  L I S T O!! 
case 36:
  return (
    <View style={styles.viewContent6}>

               <View style={styles.SelectComponentList} >
               {   
                foundUserChecker === "off" ?
                    <ChooseTypeContent 
                    navigation={ navigation } 
                    seedId={seedId}
                    origin={origin}
                    type={type} 
                    seedDescription={seedDescription}
                    seedName={seedName} 
                    seedPhoto={seedPhoto}
                    foundUserChecker={foundUserChecker}
                    seedDate={seedDate}
                    userId={userId}
                    content={content}
                    seedOrder={seedOrder}/>
                    :
                    null
                }
               </View>

          <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
          <Text style={styles.title} numberOfLines={1}> Type:  {type} </Text>
                  <Text style={styles.Title6} >
                  {title}
                </Text>
          {/* <TouchableOpacity onPress={onPress}> */}
          <View style={styles.viewContent6PhotoYText}  >
                <Text style={styles.seedDescription6} >
                  {seedDescription}
                </Text>
                <ImageHandlerDichapp
                    imageUrl={seedPhoto}
                    imageType="seed"
                    userId={userId}
                    //thumbnailUrl={thumbnailUrl}
                    styleImage={
                    styles.image7
                    }
                    styleImageVideo={styles.image7}
                    onPressImg={()=>{
                      var imageUrl = webUrl + seedPhoto + '_seedfit.jpg'
                                      navigation.navigate('Imagen', {
                                      imageUrl
                                      })

                      //console.log("Onpress en CardComponent onPressImg()")
                    }}
                    navigation={navigation}
                  />  
             </View>
          <View style={styles.detailsContainer}>
               
               <View style={styles.likeAndCommentContainer5}> 
                      <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }                      />
                      <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                            numberOfLines={2} 
                            onPress={onPressNumLikes}>
                            {subTitle}
                      </Text>
                      <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                      />
                      <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                            numberOfLines={1} >
                            {commentsNum}
                      </Text>
                </View>
                
          </View>
    </View>
);


// Add photo or Video  with Text to the ==> R I G H T <==  L I S T O!! 
case 37:
  return (
    <View style={styles.viewContent6}>

               <View style={styles.SelectComponentList} >
               {   
                foundUserChecker === "off" ?
                    <ChooseTypeContent 
                    navigation={ navigation } 
                    seedId={seedId}
                    origin={origin}
                    type={type} 
                    seedDescription={seedDescription}
                    seedName={seedName} 
                    seedPhoto={seedPhoto}
                    foundUserChecker={foundUserChecker}
                    seedDate={seedDate}
                    userId={userId}
                    content={content}
                    seedOrder={seedOrder}/>
                    :
                    null
                }
               </View>

          <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
          <Text style={styles.title} numberOfLines={1}> Type:  {type} </Text>
                  <Text style={styles.Title6} >
                  {title}
                </Text>
          {/* <TouchableOpacity onPress={onPress}> */}
          <View style={styles.viewContent6PhotoYText}  >
              
                <ImageHandlerDichapp
                    imageUrl={seedPhoto}
                    imageType="seed"
                    userId={userId}
                    //thumbnailUrl={thumbnailUrl}
                    styleImage={
                    styles.image7
                    }
                    styleImageVideo={styles.image7}
                    onPressImg={()=>{
                      var imageUrl = webUrl + seedPhoto + '_seedfit.jpg'
                                      navigation.navigate('Imagen', {
                                      imageUrl
                                      })

                      //console.log("Onpress en CardComponent onPressImg()")
                    }}
                    navigation={navigation}
                  />
                  <Text style={styles.seedDescription6} >
                    {seedDescription}
                  </Text>
             </View>
          <View style={styles.detailsContainer}>
               
               <View style={styles.likeAndCommentContainer5}> 
                      <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }                      />
                      <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                            numberOfLines={2} 
                            onPress={onPressNumLikes}>
                            {subTitle}
                      </Text>
                      <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                      />
                      <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                            numberOfLines={1} >
                            {commentsNum}
                      </Text>
                </View>
                
          </View>
    </View>
);



//  Add     Y O U T U B E  V I D E O     <===  L I S T O!!
case 38:
  return (
    <View style={styles.viewContent8}>
               <View style={styles.SelectComponentList} >
               {   
                foundUserChecker === "off" ?
                    <ChooseTypeContent 
                    navigation={ navigation } 
                    seedId={seedId}
                    origin={origin}
                    type={type} 
                    seedDescription={seedDescription}
                    seedName={seedName} 
                    seedPhoto={seedPhoto}
                    foundUserChecker={foundUserChecker}
                    seedDate={seedDate}
                    userId={userId}
                    content={content}
                    seedOrder={seedOrder}
                    />
                    :
                    null
                }
               </View>
          <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
          <View style={styles.youtubeVideo} >
              <VideoVisor videoNumber={videoNumber}/> 
          </View> 
          <View style={styles.detailsContainer}>
                <Text style={styles.Title8} >
                  {title}
                </Text>
                {/* <Hyperlink //linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                         linkDefault={ true }
                          >  */}
                   {/* <a href={seedDescription}> */}
                  
                  
                <Text style={styles.seedDescription} >
                  {seedDescription} 
                </Text>
                {/* </a> */}
                {/* </Hyperlink> */}
               <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  onPress={onPressNumLikes}>
                                  {subTitle}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {commentsNum}
                            </Text>
                </View>
          </View>
    </View>
);

// Add    R E Q U I R E M E N T  
case 39:
  return (
         <Text style={styles.title} > caso 39 prox {title}  </Text>               

  //   <View style={styles.viewContent4}>
  //   <View style={styles.SelectComponentList} >
  //              {   
  //               foundUserChecker === "off" ?
  //                   <ChooseTypeContent 
  //                   navigation={ navigation } 
  //                   seedId={seedId}
  //                   origin={origin}
  //                   type={type} 
  //                   seedDescription={seedDescription}
  //                   seedName={seedName} 
  //                   seedPhoto={seedPhoto}
  //                   foundUserChecker={foundUserChecker}
  //                   seedDate={seedDate}
  //                   userId={userId}
  //                   content={content}
  //                   seedOrder={seedOrder}
  //                   itemsRequirements={itemsRequirements}
  //                   />
  //                   :
  //                   null
  //               }
  //              </View>
  //   <Text style={styles.title} >  { dateFormated } </Text> 
  //   <Text style={styles.title} > {title}  </Text>               
  //   <Text style={styles.title} > {seedDescription}  </Text>
  //   <View style={{flexDirection: "row", justifyContent: "space-evenly"}}>
  //   <Entypo 
  //           style={{ marginLeft:(windowWidth * 0.07)}}
  //           name="share"
  //           size={textStyles.sizeBrainComments}
  //           color="grey"
  //           onPress={onPressShare} 
  //           />
  //     <Text style={styles.title} > Total de requerimientos: { qtyItemsRequirements }</Text>
  //     <TouchableOpacity  style={styles.buttonEdit}
  //                        onPress={ () => { 
  //                         addRequirement40()
  //                         }} 
  //                         >
  //             <Text style={styles.textEdit}>
  //                 Agregar 
  //             </Text>
  //     </TouchableOpacity>
  //   </View>
  //                 {
  //                   foundUserChecker === "off" ? 
  //                         <ScrollView style={
  //                           qtyItemsRequirements === 1 ? styles.flatlistCardRequirements39 :
  //                           qtyItemsRequirements === 2 ? styles.flatlistCardRequirements39extend2 :
  //                           qtyItemsRequirements === 3 ? styles.flatlistCardRequirements39extend3 : 
  //                           null}>
  //                             <FlatList // Este Flat es en caso de que seas el usuario propietario
  //                               data={itemsRequirements}
  //                               keyExtractor={(item) => item.seedId.toString()}
  //                               //ItemSeparatorComponent={ListItemSeparator}
  //                               renderItem={({ item, index }) => (
  //                                 <CardRequirements
  //                                   type = { item.type }
  //                                   title = {item.title}
  //                                   seedDescription = { item.seedDescription }
  //                                   seedId = { item.seedId }
  //                                   seedName = { item.seedName }
  //                                   seedPhoto = { item.seedPhoto }
  //                                   origin = { item.origin }
  //                                   thumbnailUrl={ item.thumbnailUrl }
  //                                   imageUrl={
  //                                     seedPhoto.includes('.mp4') ?
  //                                     seedVideoUri + seedPhoto :
  //                                     seedPhoto.includes('.mov') ?
  //                                     seedVideoUri + seedPhoto :
  //                                     webUrl + item.seedPhoto}
  //                                   screen = {0}
  //                                   qty = { item.qty }
  //                                   mesure = { item.mesure }
  //                                   unitaryPrice = { item.unitaryPrice }
  //                                   currency = { item.currency }
  //                                   sub = { item.sub }
  //                                   note = { item.note }
  //                                   ifBringRequirementItems={() => {ifBringRequirementItems()}}
  //                                   totalSeedLikes = { item.totalSeedLikes }
  //                                   totalSeedComments = { item.totalSeedComments }
  //                                   userId={ item.userId }
  //                                   onPressComment = { onPressComment }
  //                                   foundUserChecker={foundUserChecker}
  //                                   onPress={() =>{ 
  //                                     date = dateNow()
  //                                     newSeedDate = dateActions(date)
  //                                     typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
  //                                     console.log("typeActionSelect==> ", typeActionSelect)
  //                                     selectingArrangeImage(typeActionSelect)
  //                                   }}
  //                                 />
  //                               )}
  //                             />
  //                               {
  //                                 lastComponent === "last" ? 
  //                                 <View style={{height: 60}}>
  //                                 </View>
  //                                 :
  //                                 null
  //                               }
  //                       </ScrollView>
  //                       :
  //                       <ScrollView style={
  //                         qtyItemsRequirements === 1 ? styles.flatlistCardRequirements39 :
  //                         qtyItemsRequirements === 2 ? styles.flatlistCardRequirements39extend2 :
  //                         qtyItemsRequirements === 3 ? styles.flatlistCardRequirements39extend3 : 
  //                         null}>
  //                       <FlatList   // Este Flat es en caso de que no seas el propietario de la semilla 
  //                         data={itemsRequirements}
  //                         keyExtractor={(item) => item.seedId.toString()}
  //                         //ItemSeparatorComponent={ListItemSeparator}
  //                         renderItem={({ item, index }) => (
  //                           <CardRequirements
  //                             type = { item.type }
  //                             title = {item.title}
  //                             seedDescription = { item.seedDescription }
  //                             seedId = { item.seedId }
  //                             seedName = { item.seedName }
  //                             seedPhoto = { item.seedPhoto }
  //                             origin = { item.origin }
  //                             thumbnailUrl={ item.thumbnailUrl }
  //                             imageUrl={
  //                               seedPhoto.includes('.mp4') ?
  //                               seedVideoUri + seedPhoto :
  //                               seedPhoto.includes('.mov') ?
  //                               seedVideoUri + seedPhoto :
  //                               webUrl + seedPhoto}
  //                             screen = {2}
  //                             qty = { item.qty }
  //                             mesure = { item.mesure }
  //                             unitaryPrice = { item.unitaryPrice }
  //                             currency = { item.currency }
  //                             sub = { item.sub }
  //                             note = { item.note }
  //                             ifBringRequirementItems={() => {ifBringRequirementItems()}}
  //                             totalSeedLikes = { item.totalSeedLikes }
  //                             totalSeedComments = { item.totalSeedComments }
  //                             userId={ item.userId }
  //                             onPressComment = { onPressComment }
  //                             foundUserChecker={foundUserChecker}
  //                             onPress={() =>{ 
  //                               date = dateNow()
  //                               newSeedDate = dateActions(date)
  //                               typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
  //                               console.log("typeActionSelect==> ", typeActionSelect)
  //                               selectingArrangeImage(typeActionSelect)
  //                             }}
  //                             onPressShare = { onPressShare }
  //                           />
  //                         )}
  //                       />
  //                         {
  //                           lastComponent === "last" ? 
  //                             <View style={{height: 60}}>
  //                             </View>
  //                           :
  //                             null
  //                               }
  //                 </ScrollView>
  //                 }
  // </View>
);

case 40:
  return (
    <View style={styles.viewContent4}>
    <View style={styles.SelectComponentList} > </View>

    <Text style={styles.title} >  { dateFormated } </Text> 
    <Text style={styles.title} > {title}  </Text>               
    <Text style={styles.title} > {seedDescription}  </Text>
    <View style={{flexDirection: "row", justifyContent: "space-evenly"}}>
    <Entypo 
            style={{ marginLeft:(windowWidth * 0.07)}}
            name="share"
            size={textStyles.sizeBrainComments}
            color="grey"
            onPress={onPressShare} 
            />
      <Text style={styles.title} > Total de requerimientos: { qtyItemsRequirements }</Text>
    </View>

     {/* -------------------------------------------------------------- */}
     {/* Aqui empiza lo que hace el requrement */}
     {/* -------------------------------------------------------------- */}
     <View style={styles.card}>
                <View style={styles.likeAndCommentContainer5}> 
                           <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={"red"} 
                                              size={30} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                                  numberOfLines={2} 
                                  // onPress={onPressNumLikes}
                                  >
                                  {totalSeedLikes}
                            </Text>
                            <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={30} 
                                              onPress={onPressComment} 
                            />
                            <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                                  numberOfLines={1} >
                                  {totalSeedComments}
                            </Text>
                </View>

      <View style={{height: 200, width: '100%', alignItems: "center", marginBottom: "4%"}}>
       <MyPieChart />
      </View>
          
  {/* Contenedor de botones para apoyar  */}
<View style={styles.buttonsTop}>
 
{//---------------------------------------------------------------
totalSupports > 0 ?
    <View style={{marginTop: "3%"}}>
          <Text style={{fontSize: 20,  
                        color: "black",
                        marginLeft: "",
                        marginTop: ""}}>
                          Apoyos: {qtySupports.toLocaleString()}
          </Text>           
      </View>
    :
      null
}

{//--------------------------------------------------------------
  verMasApoyos === "menos" ?  
    <TouchableOpacity  style={styles.buttonVerApoyos}
                        onPress={ () => { 
                          setVerMasApoyos("mas")
                          console.log("clic ver apoyos ")
                        }} 
                      >
        <Text style={styles.textEdit}>
          Ver apoyos
        </Text>
    </TouchableOpacity>
  :
    <TouchableOpacity style={styles.buttonVerApoyos} 
                      onPress={ () => 
                        setVerMasApoyos("menos")
                      }
                    >
        <Text style={styles.textEdit}>
          Ver menos...
        </Text>
    </TouchableOpacity> 
}

          <TouchableOpacity  style={styles.buttonEdit}
                              onPress={ () => { 
                                //setRequirementStatus("completo")
                                addSupport41()
                              }} 
                            >
              <Text style={styles.textEdit}>
                Apoyar!
              </Text>
          </TouchableOpacity>            
  </View>  
{/* ---------- fin de botenes para apoyar ------------ */}

{/* ---------- conedor de imagen y unidades------------ */}
    <View style={styles.viewContent6PhotoYText}  >
        <View style={styles.viewContent6Image} > 

{/* {  
  imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
  <View style={styles.image} >
              <Foundation 
                name="mountains" 
                size={120} 
                color={colors.medium} />
  </View>
  :  
  imageUrl === 'http://18.116.234.21:5001/seedImages/Poner Foto ' ?
  <View style={styles.image} >
              <Foundation 
                name="mountains" 
                size={120} 
                color={colors.medium} />
  </View>
  :
  <Image
    onPress={onPress}
    style={styles.image}
    tint="light"
    preview={{ uri: thumbnailUrl }}
    source={{uri:imageUrl}}
    uri={imageUrl}
    resizeMode= "stretch" // Con esto logré que la imagen se adecuara a un view más pequeño!!   //"center"
  />
}   */}
<ImageHandlerDichapp
          imageUrl={seedPhoto}
          imageType="seed"
          userId={userId}
          //thumbnailUrl={thumbnailUrl}
          styleImage={
          styles.image
          }
          styleImageVideo={styles.image}
          onPressImg={()=>{
            var imageUrl = webUrl + seedPhoto + '_seedfit.jpg'
                            navigation.navigate('Imagen', {
                             imageUrl
                            })

            //console.log("Onpress en CardComponent onPressImg()")
           }}
           navigation={navigation}
/>     
        </View>
 {/* ---------- contenedor de unidades ------------ */}       
      <View style={styles.viewContent6TitleYSeedDescription}> 
           <Text style={styles.textQtyMesure}>  Concepto  </Text>
           <Text style={styles.textConceptNote} >{seedName}  </Text>
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textQtyMesure} > Cantidad </Text>
                  <Text style={styles.textQtyMesure} >          Unidad  </Text>
           </View>
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textBoxQty}> {qty}    </Text>
                  <Text style={styles.textBoxMesure}> {mesure} </Text>
                  {
                    ifShowPriceSub === "show" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setSeePriceSub("yes")}
                      name={"chevron-down"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
                  {
                    ifShowPriceSub === "dontShow" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setSeePriceSub("no")}
                      name={"chevron-up"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
           </View>

                { 
                  seePriceSub === "no" ?
                    null
                  :
                    <View >
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Precio U. </Text>
                              <Text style={styles.textQtyMesure}>    Subtotal </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxPrice}> {unitaryPrice} </Text>
                              <Text style={styles.textBoxSub}> {sub.toLocaleString()}          </Text>
                          </View>
                    </View>
                }
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Aportado </Text>
                              <Text style={styles.textQtyMesure}>          Faltan: </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxQty}> {totalSupports.toLocaleString()} </Text>
                              <Text style={styles.textBoxQty}> {requirementsToFulfill.toLocaleString()}          </Text>
                          </View>
            <Text style={styles.textConceptNote} >Nota: {seedDescription} </Text>
          </View>
          {/* ---------- fin de contenedor de unidades------------ */}
   </View>
   {/* ---------- fin de contenedor de imagenes y unidades ------------ */}
                  {
                    verMasApoyos === "mas" ?
                         <FlatList
                                data={itemsSupport}
                                keyExtractor={(item) => item.seedId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardRequirements
                                    type = { item.type }
                                    title = {item.title}
                                    seedDescription = { item.seedDescription }
                                    seedId = { item.seedId }
                                    seedName = { item.seedName }
                                    seedPhoto = { item.seedPhoto }
                                    origin = { item.origin }
                                    thumbnailUrl={ item.thumbnailUrl }
                                    imageUrl={
                                      seedPhoto.includes('.mp4') ?
                                      seedVideoUri + seedPhoto :
                                      seedPhoto.includes('.mov') ?
                                      seedVideoUri + seedPhoto :
                                      webUrl + seedPhoto}
                                    screen = {3}
                                    qty = { item.qty }
                                    mesure = { item.mesure }
                                    unitaryPrice = { item.unitaryPrice }
                                    currency = { item.currency }
                                    sub = { item.sub }
                                    note = { item.note }
                                    userName = { item.userName }
                                    userId = { item.userId }
                                    userPhoto = { item.userPhoto }
                                    ifBringRequirementItems={() => {ifBringRequirementItems()}}
                                    totalSeedLikes = { item.totalSeedLikes }
                                    totalSeedComments = { item.totalSeedComments }
                                    onPressComment = { onPressComment }
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingArrangeImage(typeActionSelect)
                                    }}
                                  />
                                )}
                              />
                      :
                        null
                  }
</View>
                 
  </View>
);

case 41:
  return (
    <View style={styles.viewContent4}>
    <View style={styles.SelectComponentList} ></View>
    <Text style={styles.title} >  { dateFormated } </Text> 
    <Text style={styles.title} > {title}  </Text>               
    <Text style={styles.title} > {seedDescription}  </Text>
    <View style={{flexDirection: "row"}}>

      <Text style={styles.title} > Total de requerimientos: { qtyItemsRequirements }</Text>
    </View>
       {/*-------------------------Aquí empieza el requerimiento --------------------------------*/}
       
       <View style={styles.cardApoyo}>
 {/* <Text style={{fontSize: 20, textAlign: "right", marginRight: "3%", marginBottom: "2%"}} >  {seedId}   {userName}   </Text>  */}
 <Text style={{fontSize: 20, textAlign: "right", marginRight: "3%", marginBottom: "2%"}} >  {userName}   </Text> 

<View style={styles.viewApoyo}  >
{ 
     unitaryPrice === 0 ?
     <View style={styles.viewContent6TitleYSeedDescriptionApoyo}>
           <View style={styles.viewBoxesApoyo}>
               <Text style={styles.textQtyMesure} > Cantidad </Text>
               <Text style={{marginLeft: '25%', 
                             fontSize: textStyles.textMedium,   //(windowWidth*.043),   //18,  
                             color: colors.textGeneral,}} > Unidad  </Text>
           </View>
           <View style={styles.viewBoxesApoyo}>
               <Text style={styles.textBoxQtyMesure}> {qty}    </Text>
               <Text style={styles.textBoxQtyMesure}> {mesure} </Text>
           </View>
           <Text style={styles.textNoteSupport} >Nota: {seedDescription} </Text>
     </View>
     :
     <View style={styles.viewContent6TitleYSeedDescriptionApoyo}>
           <View style={styles.viewBoxesApoyo}>
               <Text style={styles.textQtyMesure}> Apoyo </Text>
               <Text style={styles.textQtyMesure}>                 Unidad   </Text>
           </View>
           <View style={styles.viewBoxesApoyo}>
               <Text style={styles.textBoxQtyMesure}> {qty}    </Text>
               <Text style={styles.textBoxQtyMesure}> {mesure} </Text>
           </View>
           <View style={styles.viewBoxesApoyo}>
               <Text style={styles.textQtyMesure}> Precio U. </Text>
               <Text style={styles.textQtyMesure}>              Subtotal  </Text>
           </View>
           <View style={styles.viewBoxesApoyo}>
               <Text style={styles.textBoxQtyMesure}> {unitaryPrice} </Text>
               <Text style={styles.textBoxQtyMesure}> {sub.toLocaleString()}          </Text>
           </View>
           {/* <Text style={styles.Title6} > {seedName}  </Text> */}
           {/* <Hyperlink linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                       linkDefault={ true }
                       > */}
                 <Text style={styles.textNoteSupport} >Nota: {seedDescription} </Text>
           {/* </Hyperlink> */}
     </View>
   }

 <View style={styles.viewImageUser} > 
     { (Platform.OS === 'ios') ?  
       imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
       <View style={styles.imageUser} >
                   <Foundation 
                     name="mountains" 
                     size={(windowWidth * .25 )}         //100
                     color={colors.medium} />
       </View>
       :   
       <TouchableOpacity
       onPress={() => {
           var item = {userId, userPhoto, userName}
           var foundUserChecker = "foundUserChecker"
           {if(userId === userIdAuth){
             navigation.navigate(routes.USER_FIXO)
           }else{
           navigation.navigate(routes.FOUND_USER, { item, foundUserChecker })
           }}
         }}
       >
       <ImageCache
         style={styles.imageUser}
         tint="light"
         preview={{ uri: thumbnailUrl }}
         uri={profileUri + userId + '_' + userPhoto}
       />
       </TouchableOpacity>  
       :
       null           
     }
     { (Platform.OS === 'web') ?  
       imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
       <View style={styles.imageUser} >
                   <Foundation 
                               name="mountains" 
                               size={(windowWidth * .10 )}   //100 
                               color={colors.medium} />
       </View>
       :   
       <TouchableOpacity
       onPress={() => {
           var item = {userId, userPhoto, userName}
           var foundUserChecker = "foundUserChecker"
           {if(userId === userIdAuth){
             navigation.navigate(routes.USER_FIXO)
           }else{
           navigation.navigate(routes.FOUND_USER, { item, foundUserChecker })
           }}
         }}
       >
        <>
        <Image
         style={styles.imageUser}
         tint="light"
         preview={{ uri: thumbnailUrl }}
         source={{uri: webUrl + userId +'_'+ userPhoto.substring(0, 19) + '_userfit.jpg'}}
       />
        </>
       
       {/* <ImageHandlerDichapp
          type="profile"
          userId={userId}
          imageUrl={userPhoto}
          styleImage={styles.imageUser}
       /> */}

       </TouchableOpacity>  
       :
       null           
     }
       {/* {
         userId === userIdAuth ?
            <TouchableOpacity  style={styles.buttonEdit}
                                 onPress={ () => { 
                                   editRequirement()
                                 }} 
                               >
                 <Text style={styles.textEdit}>
                   Editar 
                 </Text>
             </TouchableOpacity>
           :
           null
       } */}
 </View>
</View>
<View style={styles.likeAndCommentContainer5}> 
                    <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                       name={"brain"} 
                                       color={colors.brain} 
                                       size={textStyles.sizeBrainComments} 
                                       onPress={ () => {
                                         onPressValidationLikeUser()
                                        }
                                       }
                     />
                     <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                           numberOfLines={2} 
                           // onPress={onPressNumLikes}
                           >
                           {totalSeedLikes}
                     </Text>
                     <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                       name={"comment-text-outline"} 
                                       color={colors.commentsIcon} 
                                       size={textStyles.sizeBrainComments} 
                                       // onPress={onPressComment}
                                       onPress={ () => {
                                           var item = {seedId}
                                           console.log("seedId en comments ", seedId)
                                           navigation.navigate(routes.COMMENTS_SEEDS, {item})
                                           }
                                         }
                     />
                     <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                           numberOfLines={1} >
                           {totalSeedComments}
                     </Text>
                     <Entypo 
                         style={{ marginLeft: (windowWidth * 0.131)}}
                         name="share"
                         size={textStyles.sizeBrainComments}
                         color="grey"
                         onPress={onPressShare} 
                     />
         </View>
         {
           verMas === "mas" ?  
               <MaterialCommunityIcons
               onPress = {()=> setVerMas("menos")}
               name={"chevron-up"}
               size={35}
               color={colors.medium}
               style={{alignSelf: "center"}}
               />
           :
               <MaterialCommunityIcons
               onPress = {()=> setVerMas("mas")}
               name={"chevron-down"}
               size={35}
               color={colors.medium}
               style={{alignSelf: "center"}}
               />
         }
         
         { (Platform.OS === 'ios') ?
           verMas === "mas" ?  
                  
                      seedPhoto === 'Poner Foto ' ?   
                      <View style={styles.imageSupport} >
                           <Foundation 
                               name="mountains" 
                               size={(windowWidth*.7)} 
                               color={colors.medium} />
                      </View>
                      :
                      String(seedPhoto).includes('.png') ?
                      <ImageCache
                          style={styles.imageSupport}
                          //preview={{ uri: webUrl + seedPhoto }}
                          preview={{ uri: thumbnailUrl }}
                          tint="light"
                          uri= { webUrl + seedPhoto }
                          //uri={imageUrl}
                      /> 
                      :
                      <ImageCache
                          style={styles.imageSupport}
                          //preview={{ uri: webUrl + seedPhoto }}
                          preview={{ uri: thumbnailUrl }}
                          tint="light"
                          uri= { webUrl + seedPhoto }
                          //uri={imageUrl}
                          //resizeMode= "cover"
                      />   
                      :  
                      null
                      :
                      null
                  }
                  <ImageHandlerDichapp
                      imageUrl={seedPhoto}
                      imageType="seed"
                      styleImageVideo={styles.imageSupport}
                      //thumbnailUrl={thumbnailUrl}
                      styleImage={
                      styles.imageSupport
                      }
                  />
       { (Platform.OS === 'web') ?
       
           verMas === "mas" ?  
                  <ImageHandlerDichapp
                      imageUrl={seedPhoto}
                      imageType="seed"
                      //thumbnailUrl={thumbnailUrl}
                      styleImage={
                      styles.imageSupport
                      }
                  />
                      // seedPhoto === 'Poner Foto ' ?   
                      // <View style={styles.imageSupport} >
                      //      <Foundation 
                      //          name="mountains" 
                      //          size={(windowWidth*.7)} 
                      //          color={colors.medium} />
                      // </View>
                      // :
                      // String(seedPhoto).includes('.png') ?
                      // <Image
                      //     style={styles.imageSupport}
                      //     //preview={{ uri: webUrl + seedPhoto }}
                      //     preview={{ uri: thumbnailUrl }}
                      //     tint="light"
                      //     //uri= { webUrl + seedPhoto }
                      //     //uri={imageUrl}
                      //     source={{uri: webUrl + seedPhoto}}

                      // /> 
                      // :
                      // <Image
                      //     style={styles.imageSupport}
                      //     //preview={{ uri: webUrl + seedPhoto }}
                      //     preview={{ uri: thumbnailUrl }}
                      //     tint="light"
                      //     source={{uri: webUrl + seedPhoto}}
                      //     //resizeMode= "cover"
                      // />   
                      :  
                      null
                      :
                      null
                  }

</View>
  </View>
);

    //Multiples photos or Videos  <===  :) !!
    case 44:
      return (
        <View style={styles.viewContent5}>

          <View style={styles.SelectComponentListForMultiImages} >
            {
              foundUserChecker === "off" ?
                <ChooseTypeContent
                  navigation={navigation}
                  seedId={seedId}
                  origin={origin}
                  type={type}
                  seedDescription={seedDescription}
                  seedName={seedName}
                  seedPhoto={seedPhoto}
                  foundUserChecker={foundUserChecker}
                  seedDate={seedDate}
                  userId={userId}
                  content={content}
                  seedOrder={seedOrder}
                  itemsRequirements={itemsRequirements}
                  tag={'EditSupportFromCardRequirements'}
                  multiImages={multiImages}
                />
                :
                null
            }
          </View>
          
      {/*................................................
              Aqui se pinta el Creador y Orígen de la semilla
             .................................................*/} 
  
          {
            //userIdSeedOwner !== JSON.parse(user).userId ?
            screen === "SearchSeedScreen" ?

              <TouchableHighlight
                onPress={
                  () => {
                    goToFoundUser1()
                  }
                }>
                <View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", alignSelf: "center" }}>
                  <Text style={styles.textImageUser} > Creador: </Text>
                    <Text style={styles.textImageUser} > {userNameSeedOwner} </Text>
                  {
                    userPhotoSeedOwner === null ?
                      null
                      :
                      userPhotoSeedOwner.includes('jpg') ?
                        <Image
                          style={styles.imageUser}
                          preview={{ uri: perfilUri + userIdSeedOwner + "_" + userPhotoSeedOwner.substring(0, 19) + '_userfit.jpg' }}
                          tint="light"
                          //uri= { webUrl + seedPhoto }
                          source={{ uri: perfilUri + userIdSeedOwner + "_" + userPhotoSeedOwner.substring(0, 19) + '_userfit.jpg' }}
                          resizeMode="cover"
                        />
                        :
                        userPhotoSeedOwner.includes('png') ?
                          <Image
                            style={styles.imageUser}
                            preview={{ uri: perfilUri + userIdSeedOwner + "_" + userPhotoSeedOwner.substring(0, 19) + '_userfit.png' }}
                            tint="light"
                            //uri= { webUrl + seedPhoto }
                            source={{ uri: perfilUri + userIdSeedOwner + "_" + userPhotoSeedOwner.substring(0, 19) + '_userfit.png' }}
                            resizeMode="cover"
                          />
                          :
                          <Foundation
                            name="mountains"
                            size={35}
                            color={colors.green} />
                  }
                </View>
              </TouchableHighlight>
              :
              null
          }

          {
            screen === "SearchSeedScreen" ?
              <TouchableOpacity
                onPress={() => {
                  console.log("onPress en image en CardOriginComponent, userIdOrigin ", userIdOrigin)
                  var item = { seedId: origin, type: typeOrigin, userId: userIdOrigin, userPhoto: userPhotoOrigin, userIdOrigin: userIdOrigin, totalActions: actionsNum }
                  var screen = "CardOriginComponent" //"SearchSeedScreen" -> Le quité el SearchSeedScreen para que no vuelva a salir este encabezado cuando te vayas al ListingDetails a ver toda la acción.                  navigation.navigate(routes.SEED_DETAILS, { item, screen, foundUserChecker })
                  navigation.navigate(routes.SEED_DETAILS, { item, screen, foundUserChecker })
                  console.log("C:C:C:C onPress en image en CardComponent, item ", item)

                }}
              >
                <View style={{ flexDirection: "row", alignItems: "center"  }}>
                    {photoOrigin &&
                        <Image
                          style={styles.imageOrigin}
                          source={
                            photoOrigin.endsWith('.jpg')
                              ? { uri: webUrl + photoOrigin + "_seedfit.jpg" }
                              : photoOrigin.endsWith('.png')
                                ? { uri: webUrl + photoOrigin + "_seedfit.png" }
                                : null
                          }
                          resizeMode="contain"
                        />
                    }
                    <Text style={styles.textOrigin}>Origen: {nameOrigin}</Text>
                  </View>
              </TouchableOpacity>
               :
               null
          }
           {/*................................................
              Aqui se pinta el carrusel de multiples imagenes
             .................................................*/} 
          
          <View style={{
            width: '100%',
            height: 450,
          }}>

            <View
              style={{ flex: 1, backgroundColor: colors.green, }}
             // initialPage={0}
             // onPageSelected={(event) => setCurrentIndex(event.nativeEvent.position)}
            >
             <FlatList
                  data={multiImages}
                  keyExtractor={(multiImage) => multiImage.seedPhotoId.toString()}
                  //ItemSeparatorComponent={ListItemSeparator}
                  //style={{backgroundColor: colors.green}}
                  horizontal={true}
                  renderItem={({ item, index }) => (
                      // <ListItemAccount
                      //     imageUrl={
                      //   // webUrl + index + multiImages[index].seedPhoto
                      //     // multiImages
                      //     //webUrl + multiImages[index].seedPhoto}
                      //     webUrl + item.seedphoto  
                      //     }
                      //   image={webUrl + item.seedphoto }
                      // />
                    <Image
                     style={{
                      width: 500,
                      height: '100%',
                    }}
                      resizeMode="contain"
                      source={{ uri: webUrl + item.seedphoto }}>

                    </Image>
                   
                  )}
              />
              {/* {multiImages.map((item) => renderPage(item, multiImages.length))} */}
            </View>
            
            <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 10 }}>
              {multiImages.map((item, index) => (

                <View key={item.seedPhotoId}>
                  <TouchableOpacity
                    onPress={() => {
                      console.log('index - >' + index + item.seedPhotoId)
                      setCurrentIndex(index)
                    }}
                    // key={item.seedPhotoId}
                    style={{
                      marginTop: index === currentIndex ? 0 : 4,
                      width: index === currentIndex ? 20 : 10,
                      height: index === currentIndex ? 20 : 10,
                      borderRadius: 25,
                      backgroundColor: index === currentIndex ? colors.green : 'gray',
                      margin: 5,
                    }}
                  />
                </View>


              ))}
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'center', }}>
              {multiImages.map((item, index) => (
                <View key={item.seedPhotoId}>
                  {
                    index === currentIndex ?
                      <Text
                        style={{
                          width: 50,
                          height: 50
                        }}
                        > 
                        {(index + 1)} / {multiImages.length}
                      </Text>
                      :
                      null
                  }
                </View>
              ))}
            </View>
          </View>


          {/* </TouchableOpacity> */}
          <View >
            <Text style={styles.dateAndLOcation} >
              {dateFormated}
            </Text>
            {
              //............................
              //pinta ubicación por mención
              //............................
              // locationRender === null ?
              //   null
              //   :
              //   String(locationRender).includes('Map') ?
              //     null
              //     :
              //     locationRender === '' ?
              //       null
              //       :
              //       <View style={{ flexDirection: 'row' }}>
              //         <Text style={styles.title} >
              //             {locationRender} loki
              //            </Text>
              //         <AntDesign onPress={() => {
              //           // alert('delete por mención en CartOriginComponent ->' + locationRender)
              //           setMesageVisible(true)
              //         }
              //         }
              //           name="delete"
              //           size={24}
              //           style={styles.texMsgLocationBtnDelete}
              //         //color="black" 
              //         />
              //       </View>
            }
            {/* <Text style={styles.title} > Type:  {type} </Text> */}
            {/* <Hyperlink linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                              linkDefault={ true }
                              > */}
            <Text style={styles.Title} >
              {title}
              </Text>
            <Text style={styles.seedDescription} >
              {seedDescription}
              </Text>
            {
              //.............................................
              // Aqui va el mapa de la ubicación
              //.............................................
              // locationRender === null ?
              //   null
              //   :
              //   locationRender.includes('Map') ?
              //     <TouchableOpacity
              //       onPress={() => {
              //         console.log('foundUserChecker  cardOriginComponent ->', foundUserChecker)
              //         console.log('seedId  cardOriginComponent ->', seedId)

              //         var imageUrl = locationRender
              //         // var seedId = seedIdForLocation
              //         navigation.navigate(routes.MAP_VISOR, { imageUrl, foundUserChecker, seedId })

              //       }}
              //     >
              //       <FontAwesome5 style={styles.mapIcon} name="map-marked-alt" size={50} color={colors.aguacateGreen} />
              //       <Text style={styles.texMsgLocationBtn}>
              //         Mostrar ubicación en mapa
              //       </Text>

              //     </TouchableOpacity>
              //     :
              //     null
            }

            <View style={styles.likeAndCommentContainer5}>
              {/* <AlertModal
                publicityExpiration={publicityExpiration}
                userIdSeedOwner={parseInt(userIdSeedOwner)}
                seedId={seedId}
                type={type}
                userId={userId}
                refreshActionRewardStatus={refreshActionRewardStatus}
                actionRewardStatus={localActionRewardStatus}
              /> */}
              {/* <LikeBrainButton onPress={() => {
                onPressValidationLikeUser()
              }}
                statusLike={statusLike}
                style={styles.likeAndCommentContainer5Icons}
              /> */}
              {/* <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                                              name={"brain"} 
                                              color={colors.brain} 
                                              size={sizeBrainComments} 
                                              onPress={ () => {
                                                onPressValidationLikeUser()
                                               }
                                              }                            /> */}
              <Text style={styles.likeAndCommentContainer5Nums} // Número de cerebros like
                numberOfLines={2}
                onPress={onPressNumLikes}>
                {subTitle}
              </Text>
              <MaterialCommunityIcons style={styles.likeAndCommentContainer5Icons}
                name={"comment-text-outline"}
                color={colors.commentsIcon}
                size={sizeBrainComments}
                onPress={onPressComment}
              />
              <Text style={styles.likeAndCommentContainer5Nums} // Número de comments
                numberOfLines={1} >
                {commentsNum}
              </Text>
              <Entypo
                style={{ marginLeft: (windowWidth * 0.128) }}
                name="share"
                size={sizeBrainComments}
                color="grey"
                onPress={onPressShare}
              />
            </View>
          </View>
        </View>
      );


// Machote para usarse para los componentes que falten
case 99:
  return (
    <View style={styles.viewContent7}>
       <Text style={styles.title} numberOfLines={1}>
                Type:  {type}
                </Text>
          {/* <TouchableOpacity onPress={onPress}> */}
            <View>
            {  
              imageUrl.includes('.mp4') ?
              <Video 
              ref = {video}
              style = {styles.image}
              source = {{
                uri: imageUrl
              }}
              useNativeControls
              resizeMode = "contain"
              isLooping
              onPlaybackStatusUpdate = {status => setStatus(() => status)}
              />
              :
              imageUrl.includes('.mov') ?
              <Video 
              ref = {video}
              style = {styles.image}
              source = {{
                uri: imageUrl
              }}
              useNativeControls
              resizeMode = "contain"
              isLooping
              onPlaybackStatusUpdate = {status => setStatus(() => status)}
              />
              : 
              imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
              <View style={styles.imageMountain} >
                          <Foundation //style={styles.imageMountain}
                                      name="mountains" 
                                      size={350} 
                                      color={colors.medium} />
              </View>
              :               
              <Image
                onPress={onPress}
                style={styles.image}
                tint="light"
                preview={{ uri: thumbnailUrl }}
                uri={imageUrl}
                source = {{ uri: webUrl + seedPhoto }} 

              />
            }
            </View>
          {/* </TouchableOpacity> */}
          <View style={styles.detailsContainer}>
                <Text style={styles.title} >
                  {title}
                </Text>
                <Text style={styles.seedDescription} >
                  {seedDescription}
                </Text>
               <View style={styles.likeAndCommentContainer}> 
                      <Text style={styles.subTitle} // Número de cerebros like
                            numberOfLines={2} 
                            onPress={onPressNumLikes}>
                            {subTitle}
                      </Text>
                      <Text style={styles.commentsNum} // Número de comments
                            numberOfLines={1} >
                            {commentsNum}
                      </Text>
                      <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                            numberOfLines={1} >
                            {actionsNum}
                      </Text>
                </View>
                <View style={styles.likeAndCommentContainer}> 
                      <MaterialCommunityIcons name={"brain"} 
                                              color={"red"} 
                                              size={35} 
                                              onPress={onPressLike}
                      />
                    <Text style={styles.comments} numberOfLines={1} >
                        <MaterialCommunityIcons name={"comment-text-outline"} 
                                                color={"grey"} 
                                                size={35} 
                                                onPress={onPressComment} 
                        /> 
                    </Text>
                </View>
          </View>
    </View>
);

break;

}

}

const styles = StyleSheet.create({
  viewContent6TitleYSeedDescriptionApoyo: {
    backgroundColor: colors.fuente,
    width: "76%",
    borderRadius: 15,
    marginLeft: "1%",
  },
  imageUser: {
    width: 74,
    height: 74,
    borderRadius: 36, 
    backgroundColor:'red',
    marginTop: "-2%",
    marginLeft: "1%",
},
  textNoteSupport: {
    fontSize: textStyles.textSmall,  //18,  
    color: colors.textGeneral,
    marginLeft: "2%",
    paddingLeft: "1.5%",
    marginBottom: "1.5%",
    marginRight: "2%",
    width: "95%", //48.5%
    backgroundColor: "white",
    borderRadius: (windowWidth*.0194),  //7,
  },
  imageSupport: {  //Imagen agregada en Support
    marginTop: "2%",
    marginLeft: (windowWidth*.03), //"1%",
    marginBottom: "3%",
    height: (windowWidth*.3),   //
    width:  (windowWidth*.3),   //        //"100%",
    backgroundColor: colors.chakra8tur,
    alignItems: "center", 
   // justifyContent: "space-evenly",
    borderRadius: (windowWidth*.02)
  },
  viewImageUser: {
    //backgroundColor: "red", //colors.chakra2ama,
    justifyContent: 'space-evenly', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
    marginLeft: "1%",
    backgroundColor: colors.fuente, // Le puse este color esperando se vuelva transparente '#00000000',
    width: "18%",
  },
  textBoxQtyMesure:{
    fontSize: textStyles.textSmall,   //(windowWidth*.043),   //17,  
    color: colors.textGeneral,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "55%",
    backgroundColor: "white",
    borderRadius: (windowWidth*.0194),  //7,
    },
  viewBoxesApoyo: {
    alignItems:'center',
    alignContent:'center',
    alignSelf:'center',
    flexDirection: "row",
    width: "100%",
    marginLeft: "2%",
    //backgroundColor: "gray",
  },
  viewApoyo: {
    borderRadius: 15,
    backgroundColor: colors.fuente,
    flexDirection: "row",
  },
  textBoxMesure:{
    fontSize: textStyles.textSmall,    //(windowWidth*.043),   //17,  
    color: colors.textGeneral,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "45%",
    backgroundColor: "white",
    borderRadius: (windowWidth * 0.0194),  //7,
    },
  textBoxSub:{
    fontSize: textStyles.textSmall,   //(windowWidth*.043),    //17,  
    color: colors.textGeneral,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "73%",
    backgroundColor: "white",
    borderRadius: (windowWidth*.0194),  //7,
    },
  textBoxPrice:{
    fontSize: textStyles.textSmall,    //(windowWidth*.043),   //17,  
    color: colors.textGeneral,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "45%",
    backgroundColor: "white",
    borderRadius: (windowWidth*.0194),  //7,
    },
  textBoxQty:{
    fontSize: textStyles.textSmall,  //(windowWidth*.043),  //17,  
    color: colors.textGeneral,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "60%",
    backgroundColor: "white",
    borderRadius: (windowWidth*.0194),  //7,
    },
  buttonsTop: {
    marginBottom:7,
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  textConceptNote: {
    fontSize: textStyles.textSmall,//(windowWidth*.043),   //18,  
    color: colors.textGeneral,
    marginTop: "1%",
    marginLeft: "2%",
    paddingLeft: "1%",
    marginBottom: "1.5%",
    width: "48.5%", 
    backgroundColor: "white",
    borderRadius: (windowWidth*.0194),  //7,
  },
  viewQtyMesure: {
    flexDirection: "row",
    width: "40%",
    marginLeft: "2%",
    //backgroundColor: "gray",
  },
  textQtyMesure: {
    marginLeft:'13%',
    fontSize: textStyles.textMedium,   //(windowWidth*.043),   //18,  
    color: colors.textGeneral,
  },
  viewContent6TitleYSeedDescription: {
    backgroundColor:  colors.chakra2ama,
    width: "130%",
    marginLeft: "2%",
  },
  buttonVerApoyos: {
    //width: 55,
    //height: 55,
   // marginLeft: "5%",
    backgroundColor: colors.primary,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    padding: 2,
    width: "23%",
   // marginRight: "5%",
  },
  flatlistCardRequirements39: {
    marginLeft: "2%",
    width: "96%",
    height: 250,
    backgroundColor: colors.fuente,
  },
  flatlistCardRequirements39extend2: {
    marginLeft: "2%",
    width: "96%",
    height: 530,
    backgroundColor: colors.chakra4azu,
  },
  flatlistCardRequirements39extend3: {
    marginLeft: "2%",
    width: "96%",
    height: 750,  
    backgroundColor: colors.chakra4azu,
  },

  likeAndCommentContainer5: {
    flexDirection: "row",
    width: "90%",
    height: 30,
    //marginLeft: "10%",
    marginTop: "1%",
    alignItems: "center",
    //backgroundColor: "green",
 },

 likeAndCommentContainer5Nums: {
  marginLeft: "10%",
  color: colors.medium,
},

likeAndCommentContainer5Icons: {
  marginLeft: "20%",
  //backgroundColor: "green",
},

  SelectComponentList:  {
    width: "100%",
    height: "0.1%",
    marginTop: "0.01%",
    alignItems: "flex-end",
    //backgroundColor: colors.fuente,
    zIndex: 1,    
  },


  viewContent4: {
    backgroundColor: colors.fondoGeneral,
    overflow: "hidden",
    marginTop: 1,
  },
  viewContent5: {
    backgroundColor: colors.fondoGeneral,
    //marginBottom: "2%",
    marginTop: 1,
    overflow: "hidden",
    //alignItems: "flex-end",
  },
  viewContent6: {
    //borderRadius: 15,
    backgroundColor: colors.fondoGeneral,
    marginBottom: 1,
    overflow: "hidden",
  },
  viewContent6PhotoYText: {
    width:'100%',
    //height:200,
    //borderRadius: 15,
    //backgroundColor: colors.fuente,
    //marginBottom: 15,
    //overflow: "hidden",
    flexDirection: "row",
  },
  viewContent6Image: {
    backgroundColor: "red", //colors.chakra2ama,
    justifyContent: 'center', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
    //alignItems: 'center',
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
  },
  viewContent7TitleYSeedDescription: {
   // backgroundColor: colors.chakra4azu,
   flexDirection: "row",
   marginTop: "3%",
    //width: "15%",
    marginLeft: "2%",
  },
  viewContent7Image: {
    //backgroundColor: "red", //colors.chakra2ama,
    justifyContent: 'center',
    //alignItems: 'center',
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
  },
  viewContent7: {
   // borderRadius: 15,
    backgroundColor: colors.chakra7ryo,
    //marginBottom: 15,
    overflow: "hidden",
  },
  viewContent8: {
    // borderRadius: 15,
    // backgroundColor: colors.chakra8tur,
     //marginBottom: 15,
     overflow: "hidden",
   },
   viewContent9: {
    //borderRadius: 15,
    //backgroundColor: colors.chakra9aur,  // No borrar este estilo porque aunque esta comentado ahorita lo descomento a veces para ver errores.
    //marginBottom: 15,
    //overflow: "hidden",
  },
  
  detailsContainer: {
    padding: 5,
    //backgroundColor: "green",
  },

  image: {
    marginLeft:'2%',
    marginTop: "2%",
    width: 120,  // Para que funcione resizeMode= "stretch" en las propiedades de ImageCache arriba tanto width como heigth deben estar en pixeles, ninguno en porcentajes.
    height: 120,  
    //backgroundColor: colors.chakra8tur,
  },
  image4: {
    width: "50%",
    height: 250,
  },
  image5: {
    width: "100%",
    height: 400,
    //marginLeft: "0.5%",
    marginTop: "2%",
    //marginBottom: "2%",
   // backgroundColor: "green",
  },
  image6: {
    width: 200,//"380%", // A menor porcentaje en el marginLeft se requiere aumentar el width para que la foto se haga cuadrada en vez de rectangular.
    height: 200,
    marginLeft: "10%", // Cada que reducia el marginLeft me hacía la foto más rectangular, tuve que aumentar el width.
  },
  image7: {
    width: 200, // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
    height: 200,
    marginTop: "5%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
    //alignContent: "space-around",
    //backgroundColor: "blue",
  },
  imageMountain: {
    width: "100%",
    height: 350,
    alignItems: "center",
    backgroundColor: "white",
  },
  imageViewViewer: {
    //marginTop: "1%",
    //marginLeft: "2%",
    overflow: "hidden",
    width: "100%",
    height: 250,
    //backgroundColor: "blue",
  },
  imageViewViewerExcell: {
    //marginTop: "1%",
    //marginLeft: "2%",
    overflow: "hidden",
    width: "100%",
    height: 120,
    //backgroundColor: "blue",
  },
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: 30,
  },
 
  likes: {
    marginLeft: "20%",
 },
  actionsNum:{
  marginLeft: "42%",
  color: colors.medium
 },
 commentsNum:{
  marginLeft: "42%",
  color: colors.medium
 },
 comments:{
  marginLeft: "35%",
  color: colors.medium,

 },
 seedDescription: {
  width: "95%",
  textAlign: "justify",
  marginLeft: "2%",
  marginBottom: 7,
  marginTop: "1.5%",
  //backgroundColor: "green",
},
seedDescription6: {
  marginBottom: 7,
  marginTop: "1.5%",
  width: "50%",
  textAlign: "justify",
  //backgroundColor: "green",
},
 tree:{
  marginLeft: "35%",
  color: colors.medium,
 },
  subTitle: {
    color: colors.medium,
    marginLeft: "4%"
  },
  title: {
    marginBottom: 1,  // Este margen lo puse muy pequeño porque se va haciendo más grande en cada acción más abajo. Crece exponencialmente :(
    marginLeft: "2%",
    paddingLeft: "1%",
    justifyContent: "space-between",
  },
  Title:{
    fontSize: 22,  
    color: "black",
    marginLeft: "1.5%", 
    width: "95%",
    textAlign: "justify",
    },
  Title6:{
    fontSize: 22,  
    color: "black",
    alignSelf: "center",
    //marginLeft: "32%",
    //marginTop: "-10%", 
   // width: "350%",
    textAlign: "justify",
    },
  Title8:{
    fontSize: 22,  
    color: "black",
    marginTop: "10%", // Esto se lo tuve que poner porque el view de youtube trae a fuerza un tramo excedido que baja el titulo y la descripción. Si quieres ver que tan excedido descomenta el background color pistache del youtubeVideo. 
    marginLeft: "1.5%", 
    width: "95%",
    textAlign: "justify",
    },
  resizeScreen:{
    fontSize: 22,  
    color: colors.medium,
    marginTop: 2, // Esto se lo tuve que poner porque el view de youtube trae a fuerza un tramo excedido que baja el titulo y la descripción. Si quieres ver que tan excedido descomenta el background color pistache del youtubeVideo. 
    marginLeft: "1.5%", 
    width: "95%",
    textAlign: "justify",
    height: 30,
    },
  youtubeVideo: {
    width: "100%",
    marginTop: "2%",
    height: 300,
   // backgroundColor: colors.pistache,
    },

    // Inicia css de la semilla o accion original.
    detailsContainerSeed: {     //Contenedor de primera línea botones
      flexDirection: "row",
      width: "100%",
      //backgroundColor: "green",
      overflow: "hidden",
    },
    imageSeed: {
      marginTop: "1%",
      marginBottom: "1%",
      marginLeft: "2%",
      width: 250,
      height: 250,
      backgroundColor: "green",
    },
    imageVideoSeed: {
      width: 250,
      height: 250,
      //flexDirection:"row",
      alignSelf: "center",
      alignItems: "center",
      //backgroundColor: "blue",
      //marginTop: 50,
      //marginBottom: 50,
      //borderRadius: 5,
    },
    treeFollowersIconsContainer: {
      marginTop: "2%",
      marginBottom: "1%",
      marginLeft: "2%",
      //flexDirection: "row",
       alignItems: "center",
      // alignContent: "center",
      //height: "20%",
      backgroundColor: colors.pistache,
    },
    treeSeed:{
      marginLeft: "10%",
      //color: colors.dark,
      color:  "green",
      marginTop: "2%",
     },
     textFollowers: {
      //color: colors.medium,
      color: colors.green,
      fontWeight: "900",
      marginTop: "2%",
      marginLeft: "6%",
     },
     numbersActionsFollowers: {
      color: colors.dark,
      marginTop: "4%",
     },
     numbersFollowers: {
      color: colors.dark,
      marginTop: "-2%",
      marginBottom: "2%",
     },
    viewDescription: {
      marginTop: "1%",
      marginLeft: "4%",
      width: "92%",
      //height: "25%", 
    }, 
    description: {
      color: colors.greyDescription,
      //fontWeight: "bold",
      fontSize: 17,
      //marginVertical: 10,
      marginRight: "2%",
      marginLeft: "2%",
      marginTop: "1%",
      textAlign: "justify",
      backgroundColor: "yellow",
    },
    seedTitle:{
      marginTop: 1,
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra0red,
      //backgroundColor: "blue",

    },
    seedTitle1:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra1nar,
    },
    seedTitle2:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra2ama,
    },
    seedTitle3:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra3ver,
    },
    seedTitle4:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra4azu,
    },
    seedTitle5:{
      marginTop: "1%",
      width: "100%", 
     //alignItems: 'center',
      backgroundColor: colors.chakra5vlt,
    },
    seedTitle6:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra6rsa,
      //pink
    },
    seedTitle7:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra7ryo,
    },
    seedTitle8:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra8tur,
    },
    seedTitle9:{
      marginTop: "1%",
      width: "100%", 
      //alignItems: 'center',
      backgroundColor: colors.chakra9aur,
    },
    titleSeed: {
      color: colors.dark,
      //fontWeight: "bold",
      textAlign: "justify",
      fontSize: 18,
      marginTop: "2%",
      width: "90%",
      fontWeight: "500",
      textAlign: "justify",
      //backgroundColor: "green",

    },
    ContainerButtonEdit: {
      marginTop: "9%",
      height: 35,  // Esta madre la tenía en porcentaje y me estaba generando un fantasma en blanco¡¡ Recuerda no usar ningún heght en porcentaje¡¡¡¡ no mameeees 6 horas perdidas me carga la chi....
      width: "45%",
    },
    buttonEdit: {
     // marginLeft: "2%",
      backgroundColor: colors.primary,
      borderRadius: 15,
      justifyContent: "center",
      alignItems: "center",
      padding: 2,
      width: "20%",
     // marginRight: "5%",
    },
    textEdit: {
      color: colors.white,
      fontSize: 18,
      // width: '100%',
//height: '100%',
     
    },
    imageMountainSeed: {
      //width: "100%",
      //height: 250,
      alignItems: "center",
      backgroundColor: "green",
    },
  // Aqui termina todo el css de la semilla
  
 
});

export default CardComponent;


